<template>
  <div>
    <!-- NUEVO REGISTRO / EDITAR REGISTRO -->
    <div>
      <div @click="isVisibleNuevoRegistro = !isVisibleNuevoRegistro">
        <h3 class="py-2 border-collapse">{{ titleNuevoRegistro }}</h3>
      </div>

      <div class="maintenance-dashboard mt-4" v-if="isVisibleNuevoRegistro">
        <!-- <h2 class=" text-start font-weight-bold mb-5">Panel de Mantenimiento</h2> -->
        <span class="h3 font-weight-bold p-4">¡Selecciona el tipo de mantenimiento que vas a realizar!</span>
        <PasoAPaso numero="1" descripcion="Paso 1, por favor seleccione una categoria" class="w-100 mt-4 p-4">
          <div class="cards-container mt-4">
            <cardInfo tipo="preventivo" titulo="Mantenimiento Preventivo"
              descripcion="Programación y control de mantenimientos para prevenir fallos"
              :selectedCard="tipoSeleccionado" @seleccionar="seleccionarTipo" />

            <cardInfo tipo="correctivo" titulo="Mantenimiento Correctivo"
              descripcion="Reparaciones y soluciones para fallos detectados" :selectedCard="tipoSeleccionado"
              @seleccionar="seleccionarTipo" />

            <cardInfo tipo="alistamiento" titulo="Alistamiento"
              descripcion="Preparación y verificación de vehículos para operación" :selectedCard="tipoSeleccionado"
              @seleccionar="seleccionarTipo" />

            <cardInfo tipo="autorizaciones" titulo="Autorizaciones"
              descripcion="Gestión de permisos y autorizaciones para mantenimientos" :selectedCard="tipoSeleccionado"
              @seleccionar="seleccionarTipo" />
          </div>
        </PasoAPaso>

        <HXContentCardComponentes :title="nombreMantenimientoSeleccionado" v-if="tipoSeleccionado != null"
          class="p-0 m-0 w-100">
          <div>
            <PasoAPaso numero="2" descripcion="Paso 2, por favor validar la información" class="w-100 p-4">
              <div class="alert" :class="statusClass" v-if="registrationStatus !== 'pending'">
                <i class="fas" :class="statusIcon"></i>
                {{ statusMessage }}
              </div>

              <div class=" mb-4 p-3  rounded">
                <span class="font-weight-bold h5 mb-3">Información del Vehículo</span>
                <div class="row">
                  <div class="col-md-4">
                    <div class="info-item">
                      <span class="font-weight-bold mr-2">Placa:</span>
                      <span>{{ vehiculo.placa }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-4 p-3  rounded">
                <span class="font-weight-bold h5 mb-3">Información del Vigilado</span>
                <div class="row">
                  <div class="col-md-6">
                    <div class="info-item">
                      <span class="font-weight-bold mr-2">NIT:</span>
                      <span>{{ usuario.empresa.nit }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-item">
                      <span class="font-weight-bold mr-2">Empresa:</span>
                      <span>{{ usuario.empresa.nombre }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <vs-button @click="confirmarMantenimiento" animation-type="vertical">
                  Confirmar información
                  <template #animate>
                    <i class="fa-solid fa-check"></i>
                  </template>
                </vs-button>
              </div>
            </PasoAPaso>


          </div>
        </HXContentCardComponentes>
      </div>

    </div>


    <!-- HISTORIAL -->
    <div>
      <div @click="isVisibleHistorial = !isVisibleHistorial">
        <h3 class="py-2 border-collapse">Últimos registros</h3>
      </div>

      <div v-if="isVisibleHistorial" class="p-4">
        <div v-if="datosApiRegistrados.length" class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tipo mantenimiento</th>
                <th>Fecha de Registro</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in datosApiRegistrados" :key="index">
                <td>{{ item.mantenimiento_id }}</td>
                <td>
                  {{ item.tipo_identificacion }}
                </td>
                <td>{{ formatDate(item.updated_at) }}</td>

                <td>
                  <button class="btn btn-sm btn-outline-info" @click="openModal(item)">
                    Ver Detalles
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">
          No hay registros en el historial.
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import cardInfo from '../../../../components/cards/cardInfo.vue';
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';


import HXContentCardComponentes from "../../../../components/helexium/HXContentCardComponentes.vue";

export default {
  components: {
    cardInfo,
    HXContentCardComponentes,
  },
  props: {
    vehiculo: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      usuario: null,
      mantenimientoId: null,
      historial: [],
      historialKey: 'mantenimientos_historial',
      isVisibleNuevoRegistro: true,
      isVisibleHistorial: true,
      titleNuevoRegistro: 'Registro de mantenimiento',
      isLoading: false,
      registrationStatus: 'pending', // pending, registered, error
      errorMessage: '',
      tipoSeleccionado: null,
      vigiladoId: '8920005656',

      datosApiRegistrados: [],
      mantenimientoDataModal: []
    }
  },
  computed: {
    ...mapGetters(['useMoment']),

    statusClass() {
      return {
        'alert-success': this.registrationStatus === 'registered',
        'alert-danger': this.registrationStatus === 'error'
      }
    },
    statusIcon() {
      return {
        'fa-check-circle': this.registrationStatus === 'registered',
        'fa-exclamation-circle': this.registrationStatus === 'error'
      }
    },
    statusMessage() {
      if (this.registrationStatus === 'registered') {
        return `Autorización registrada exitosamente con ID: ${this.mantenimientoId}`;
      } else if (this.registrationStatus === 'error') {
        return `Error: ${this.errorMessage}`;
      }
      return '';
    },
    isInputEnabled() {
      console.log("El historial es", this.historial);

      if (this.historial.length > 0) {
        return this.historial.map((v) => ({
          idMantenimiento: v.id,
          placaVehiculo: v.placa,
          vigiladoId: v.vigiladoId,
          tipoMantenimiento: v.tipoMantenimiento,
          registroMantenimiento: false // Ya sabes que hay historial porque pasaste el if
        }));
      } else {
        return [{
          idMantenimiento: 0,
          placaVehiculo: 0,
          vigiladoId: 0,
          registroMantenimiento: true
        }];
      }
    },

  },
  async mounted() {
    await this.obtenerToken();
    await this.obtenerTokenParametricas();
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.cargarHistorialDesdeLocalStorage();
  },
  methods: {

    async obtenerToken() {
      try {
        const respuesta = await this.$store.dispatch("hl_post_cookie",
          {
            path: 'ApiSuperTransporteGenerales/TokenApiSuperTransporte'
          }
        )
        console.log("Token obtenido", respuesta);

      } catch (error) {
        console.warn("No se ha logrado generar el token", error);

      }
    },
    async obtenerTokenParametricas() {
      try {
        const respuesta = await this.$store.dispatch("hl_post_cookie",
          {
            path: 'ApiSuperTransporteGenerales/TokenParametricas'
          }
        )
        console.log("Token parámetricas obtenido", respuesta);

      } catch (error) {
        console.warn("No se ha logrado generar el token de parámetricas", error);

      }
    },

    seleccionarTipo(tipo, titulo) {
      this.tipoSeleccionado = tipo
      this.nombreMantenimientoSeleccionado = titulo

      this.registrationStatus = 'pending'
    },

    openModal(mantenimientoData) {
      console.log("La data es", mantenimientoData);
      if (mantenimientoData.tipoMantenimientoDescripcion == 'Alistamiento') {
        this.$bvModal.show("modalAlistamiento");
      }
      else if (mantenimientoData.tipoMantenimientoDescripcion == 'Autorizaciones') {
        this.$bvModal.show("modalAutorizaciones");
      }
      else {
        this.$bvModal.show("modalMantenimiento");
      }
      this.mantenimientoDataModal = mantenimientoData
    },

    cerrarRegistro() {
      Swal.fire({
        title: '¿Está seguro de cerrar el registro?',
        text: "Una vez cerrado no se podrá volver a modificar",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Cerrar registro'
      }).then(result => {
        if (result.isConfirmed) {
          // Actualizar el estado en el historial
          this.cerrarRegistroHistorial(this.mantenimientoId);

          this.mantenimientoId = null;
          this.registrationStatus = 'pending';

          Swal.fire('Registro cerrado', '', 'success');
        }
      });
    },

    cerrarRegistroHistorial(id) {
      const index = this.historial.findIndex(item => item.id === id);
      if (index !== -1) {
        this.historial[index].estado = 'Cerrado';
        this.guardarHistorialEnLocalStorage();

        if (id === this.mantenimientoId) {
          this.mantenimientoId = null;
          this.registrationStatus = 'pending';
        }
      }
    },

    formatDate(date) {
      if (!date) return 'N/A';

      if (typeof date === 'string') {
        date = new Date(date);
      }

      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    getStatusBadgeClass(estado) {
      switch (estado) {
        case 'Registrado':
          return 'badge-primary';
        case 'Cerrado':
          return 'badge-success';
        default:
          return 'badge-secondary';
      }
    },

    guardarHistorialEnLocalStorage() {
      const historialKey = `${this.historialKey}_901385215`;
      localStorage.setItem(historialKey, JSON.stringify(this.historial));
    },

    async cargarHistorialDesdeLocalStorage() {
      const historialKey = `${this.historialKey}_901385215`;
      const historialGuardado = localStorage.getItem(historialKey);
      //console.log("HistorialObtenido", historialGuardado);


      if (historialGuardado) {
        try {
          this.historial = JSON.parse(historialGuardado);
          await this.obtenerDatosApi(this.historial);
          // Convertir las fechas de string a objetos Date
          this.historial.forEach(item => {
            if (item.fechaRegistro && typeof item.fechaRegistro === 'string') {
              item.fechaRegistro = new Date(item.fechaRegistro);
            }
          });
        } catch (e) {
          console.error("Error al cargar historial:", e);
          this.historial = [];
        }
      }
    },
    async confirmarMantenimiento() {
      if (!this.vehiculo || !this.vehiculo.placa) {
        Swal.fire('Error', 'No se ha especificado la placa del vehículo', 'error');
        return;
      }


      try {
        this.isLoading = true;
        this.registrationStatus = 'pending';

        // Preparar los datos para el registro
        const datosRegistro = {
          //Cambiar el vigiladoid por this.usuario.empresa.nit
          vigiladoId: this.vigiladoId,
          placa: this.vehiculo.placa,
          tipoId: parseInt(this.tipoSeleccionado == 'preventivo' ? 1 : this.tipoSeleccionado == 'correctivo' ? 2 : this.tipoSeleccionado == 'alistamiento' ? 3 : this.tipoSeleccionado == 'autorizaciones' ? 4 : 'Invalido'),
        };

        console.log("Enviando datos:", datosRegistro);

        const resultado = await this.$store.dispatch('hl_post_cookie', {
          path: 'ApiSuperTransporteMantenimientos/registrar-mantenimiento',
          data: datosRegistro
        })

        console.log("Respuesta del servidor:", resultado);

        if (resultado == 'Ya existe un registro inciado para esta placa, valide el listado') {
          Swal.fire({
            icon: 'warning',
            title: 'Error al registrar',
            text: `Ya hay un mantenimiento preventivo pendiente para esta placa ${this.vehiculo.placa}`,
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        // Guardar el ID del mantenimiento
        this.mantenimientoId = resultado.id;
        this.registrationStatus = 'registered';

        // Añadir al historial
        const nuevoRegistro = {
          id: this.mantenimientoId,
          placa: this.vehiculo.placa,
          tipoMantenimiento: parseInt(this.tipoSeleccionado == 'preventivo' ? 1 : this.tipoSeleccionado == 'correctivo' ? 2 : this.tipoSeleccionado == 'alistamiento' ? 3 : this.tipoSeleccionado == 'autorizaciones' ? 4 : 'Invalido'),
          vigiladoId: this.vigiladoId,
          fechaRegistro: new Date(),
          estado: 'Registrado',
        };

        this.historial.unshift(nuevoRegistro);
        this.guardarHistorialEnLocalStorage();

        Swal.fire({
          icon: "success",
          title: "Registro exitoso",
          text: `Se ha registrado la autorización`,
          confirmButtonText: "Aceptar",
        });
        this.isInputEnabled;
      } catch (error) {
        console.error("Error al registrar:", error);
        this.errorMessage = error.message || "Error desconocido";
        this.registrationStatus = 'error';

        Swal.fire({
          icon: 'error',
          title: 'Error al registrar',
          text: this.errorMessage,
          confirmButtonText: 'Aceptar'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async obtenerDatosApi(registros) {
      this.datosApiRegistrados = []; // Inicializa como array para acumular resultados

      const tipoMantenimientoMap = {
        1: "Mantenimiento preventivo",
        2: "Mantenimiento correctivo",
        3: "Alistamiento",
        4: "Autorizaciones"
      };

      
      
      for (const registro of registros) {
        const id = registro.id;
        const tipo = registro.tipoMantenimiento;
        let resultado = null;
        try {
          if (tipo === 1) {
            resultado = await this.$store.dispatch('hl_get_cookie', {
              path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=1&idMantenimiento=${id}`,
            })
          } else if (tipo === 2) {
            resultado = await this.$store.dispatch('hl_get_cookie', {
              path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=2&idMantenimiento=${id}`,
            })
          } else if (tipo === 3) {
            resultado = await this.$store.dispatch('hl_get_cookie', {
              path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=3&idMantenimiento=${id}`,
            })
          } else if (tipo === 4) {
            resultado = await this.$store.dispatch('hl_get_cookie', {
              path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=4&idMantenimiento=${id}`,
            })
          } else {
            console.warn("Tipo mantenimiento incorrecto", id);
            continue;
          }

          if (resultado) {
            console.log("El resultado es", resultado);
            
            resultado.tipo_identificacion = tipoMantenimientoMap[tipo] || "Desconocido";
            this.datosApiRegistrados.push(resultado);
          }
        } catch (error) {
          console.error(`Error procesando el ID ${id}:`, error);
        }
      }
    }

  }
}
</script>

<style scoped>
.border-collapse {
  border-bottom: .5px solid #dee2e6;
  cursor: pointer;
}

.maintenance-dashboard {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-title {
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 600;
  font-size: 1.8rem;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-title {
    font-size: 1.5rem;
  }
}
</style>
